import { graphql } from '@eluve/graphql.tada';

export const patientImportJobListItemFragment = graphql(`
  fragment PatientImportJobListItem on PatientImportJobs @_unmask {
    __typename
    id
    tenantId
    patientImportSourceId
    filename
    status
    totalRows
    committedCount
    failedCount
    skippedCount
    failureCategory
    failureMessage
    createdBy
    createdAt
    updatedAt
    finalizedAt
    cancelledAt
  }
`);

export const patientImportJobDetailFragment = graphql(`
  fragment PatientImportJobDetail on PatientImportJobs @_unmask {
    __typename
    id
    tenantId
    patientImportSourceId
    userUploadId
    filename
    status
    totalRows
    unknownHeaders
    missingRequiredHeaders
    committedCount
    failedCount
    skippedCount
    failureCategory
    failureMessage
    createdBy
    createdAt
    updatedAt
    finalizedAt
    cancelledAt
  }
`);

export const getPatientImportJobQuery = graphql(
  `
    query getPatientImportJob($tenantId: uuid!, $jobId: uuid!) {
      patientImportJobsByPk(tenantId: $tenantId, id: $jobId) {
        ...PatientImportJobDetail
      }
    }
  `,
  [patientImportJobDetailFragment],
);

export const findPatientImportJobByIdQuery = graphql(`
  query findPatientImportJobById($jobId: uuid!) {
    patientImportJobs(where: { id: { _eq: $jobId } }, limit: 1) {
      __typename
      id
      tenantId
    }
  }
`);

export const listTenantsForPickerQuery = graphql(`
  query listTenantsForPicker {
    adminTenants(
      orderBy: { name: ASC }
      where: { isRealTenant: { _eq: true } }
    ) {
      __typename
      id
      name
    }
  }
`);

export const listPatientImportJobsAcrossTenantsQuery = graphql(
  `
    query listPatientImportJobsAcrossTenants {
      patientImportJobs(orderBy: { createdAt: DESC }, limit: 200) {
        ...PatientImportJobListItem
      }
    }
  `,
  [patientImportJobListItemFragment],
);
